import type { Tokens } from '../augmentation'

import { type ComponentCreation } from './types'

export const createMuiBackdrop = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiBackdrop: {
      styleOverrides: {
        root: {
          '&:not(.MuiBackdrop-invisible)': {
            backgroundColor: palette.components.backdrop.fill,
          },
        },
      },
    },
  }) satisfies ComponentCreation
